import styled from 'styled-components';
import Image from 'components/Image';
import { ORANGE } from 'root/theme';

const BadgeContainer = styled.div`
  text-decoration: inherit;
`;

const BadgeName = styled.div`
  color: ${ORANGE};
  min-height: 50px;
`;

const BadgeDescription = styled.div`
`;

const BadgeImage = styled(Image)`
  margin-bottom: 0.5rem;
`;

export { BadgeContainer, BadgeName, BadgeDescription, BadgeImage };
